/**
 * In-memory selected-project store. Mirrors `jwtStore.ts`:
 * closure-captured value, `useSyncExternalStore`-friendly subscribe API,
 * cleared on `auth:logout` (via `ProjectCacheCleaner`).
 *
 * The fetch wrapper reads `projectStore.get()` to attach the `ProjectId`
 * request header on every patient-registry call except `/auth/identity`.
 *
 * No persistent storage. Tab close / refresh discards.
 */

let selectedProjectId: string | null = null;
const listeners = new Set<() => void>();

function notify() {
    for (const listener of listeners) listener();
}

export const projectStore = {
    get(): string | null {
        return selectedProjectId;
    },
    set(projectId: string): void {
        selectedProjectId = projectId;
        notify();
    },
    clear(): void {
        selectedProjectId = null;
        notify();
    },
    subscribe(listener: () => void): () => void {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
};

/** Test-only reset. */
export function __resetProjectStoreForTests(): void {
    selectedProjectId = null;
    listeners.clear();
}
